import { PlayerTypes, PlayerActions, IMediaItem, IMediaList } from "../types"

export interface IPlayerState {
  list: IMediaList
  current: IMediaItem
  play: boolean
  prevItem: IMediaItem
  listID: number
}
const initalState: IPlayerState = {
  list: [],
  listID: null,
  play: false,
  current: null,
  prevItem: null
}

function setAutoplayUptoIndex(list: IMediaList, i: number)
{
        list.forEach(element => {
        element.autoplayExcluded = false;
      });
      if (i >= 0) {
        for (let index = 0; index < i; index++) {
          const element = list[index];
          element.autoplayExcluded = true;
        }
      }
  return list;
}

export default (state = initalState, action: PlayerActions) => {
  const currentIndex = state.list.findIndex(el => el.idx === state.current.idx)
  let nextIndex = currentIndex + 1 < state.list.length ? currentIndex + 1 : 0
  switch (action.type) {
    case PlayerTypes.PLAY:
      if (!action.current) {
        return { ...state, play: true }
      }
      const i = action.list.findIndex(x => x == action.current);
      action.list = setAutoplayUptoIndex(action.list, i);
      return {
        ...state,
        play: true,
        list: action.list,
        prevItem: state.current ? state.current : action.current,
        current: action.current,
        listID: action.listID
      }
    case PlayerTypes.PAUSE:
      return {
        ...state,
        play: false
      }
    case PlayerTypes.NEXT_SONG:
      if (currentIndex < 0) {
        return state
      }
       state.list = setAutoplayUptoIndex (state.list, nextIndex) 
      return {
        ...state,
        current: state.list[nextIndex],
        prevItem: state.current 
      }
    
    case PlayerTypes.NEXT_JOINED_SONG:
      let playListNextItemIndex = -1
      if (state.current) {
        state.current.autoplayExcluded = true;
      }
      if (state.current.playListNextItem >= 0) {
        playListNextItemIndex = state.list.findIndex(el => el.periodItemIndex == state.current.playListNextItem)
      }
      if (playListNextItemIndex>=0 && !state.list[playListNextItemIndex].autoplayExcluded)
      {
        const prevItem = state.list[playListNextItemIndex - 1 >= 0 ? playListNextItemIndex - 1 : 0];
        return {
        ...state,
        current: state.list[playListNextItemIndex],
        prevItem: prevItem
      }
      }
    else
{
        
  if (currentIndex < 0) {
        return state
  }
        const foundNextIndex = state.list.findIndex(x => x.autoplayExcluded == false)
        nextIndex = foundNextIndex >= 0 ? foundNextIndex : nextIndex;
      return {
        ...state,
        current: state.list[nextIndex],
        prevItem: state.list[nextIndex - 1>=0 ? nextIndex -1 : 0]
      }}
    
    case PlayerTypes.PREV_SONG:
      const prevIndex = state.list.findIndex(el => el.idx === state.current.idx)
      if (prevIndex < 0) {
        return state
      }
      const prevIndexNormalized = prevIndex - 1 >= 0 ? prevIndex - 1 : 0;
      state.list=setAutoplayUptoIndex(state.list, prevIndexNormalized)
      return {
        ...state,
        current: state.list[prevIndexNormalized],
        prevItem: state.current 
      }
    default:
      return state
  }
}
